import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IVoteProps } from './IVoteProps';
import { VoteQuestionExecutorModal } from './VoteQuestionExecutorModal';

export const VoteQuestionExecutor = createDocModalExecutor<IVoteProps>({
    modal: VoteQuestionExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        action: action,
        userType: action.options?.userType ?? 'secretary',
        participantVote: action.options?.participantVote,
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
